"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _src = _interopRequireDefault(require("../src"));

require("datatables.net-bs4");

require("datatables.net-responsive/js/dataTables.responsive.js");

require("datatables.net-responsive-bs4/js/responsive.bootstrap4.js");

require("datatables.net-buttons-bs4");

require("datatables.net-select-bs4");

require("datatables.net-select-bs4/css/select.bootstrap4.min.css");

require("datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css");

require("datatables.net-responsive-bs4/css/responsive.bootstrap4.css");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// this demonstrate with buttons and responsive master/details row
// import buttons and plugins
// import 'datatables.net-buttons/js/dataTables.buttons.js'
// import 'datatables.net-buttons/js/buttons.html5.js'
// import 'datatables.net-buttons/js/buttons.print.js'
// import the rest
var _default = {
  name: 'ShipOperationsArrivals',
  components: {
    VdtnetTable: _src["default"]
  },
  data: function data() {
    var _this = this;

    var vm = this;
    return {
      //fields: this.$parent.fields,
      options: {
        ajax: {
          url: this.$parent.url,
          dataSrc: this.$parent.limit == 0 && this.$parent.type == 'all' ? 'escales' : function (json) {
            return json.escales.filter(function (item) {
              return _this.$parent.type.includes(item.DESCVAITIPUS);
            }).filter(function (item, index) {
              return index < _this.$parent.limit;
            });
          }
        },
        buttons: [],
        responsive: true,
        processing: true,
        searching: false,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: false,
        serverSide: false,
        fixedHeader: true,
        saveState: true,
        info: false,
        paging: this.$parent.limit == 0 ? true : false,
        pageLength: 20
      },
      fields: {
        HETA: {
          label: 'Arriba a',
          sortable: true,
          render: function render(data, type, row) {
            return "<span class=\"icon ".concat(row.DESCVAITIPUS.toLowerCase().replace(' ', '-'), "\"></span>").concat(data);
          }
        },
        AUXNOMVAIXELL: {
          label: 'Vaixell',
          sortable: true
        },
        DESCVAITIPUS: {
          label: 'Tipus de vaixell'
        },
        DESCPORTDESTI: {
          label: 'Origen'
        },
        DESCESTOPERATIU: {
          label: 'Estat operatiu'
        },
        NUMESCALA: {
          label: 'Número d’Escala'
        },
        NOMTERMINAL: {
          label: 'Nom Terminal'
        },
        MMSI: {
          label: 'Codi del vaixell'
        },
        ESLORA: {
          label: 'Eslora'
        },
        ETA: {
          label: 'Data estimada arribada'
        },
        USUNOMRAOSOCIAL: {
          label: 'Raó social'
        }
      },
      quickSearch: '',
      details: {}
    };
  },
  methods: {}
};
exports["default"] = _default;